import {ValueObject} from '@s-ui/domain'

/**
 * @implements ValueObject
 * Motor Form
 */
export class DraftFormValueObject extends ValueObject {
  /**
   * @param {Object}   draft
   * @param {Number}   draft.id
   * @param {String}   draft.bodyTypeDoors
   * @param {String}   draft.carPlate
   * @param {Number}   draft.colour
   * @param {String}   draft.comments
   * @param {String}   draft.email
   * @param {String}   draft.environmentalLabel
   * @param {Number}   draft.fuelId
   * @param {Array}    draft.images
   * @param {Number}   draft.makeId
   * @param {Number}   draft.mileage
   * @param {Number}   draft.modelId
   * @param {String}   draft.phone
   * @param {String}   draft.plateRegistrationDate
   * @param {Number}   draft.price
   * @param {Number}   draft.provinceId
   * @param {Boolean}  draft.publishInMA
   * @param {Number}   draft.transmissionTypeId
   * @param {Number}   draft.userId
   * @param {Number}   draft.versionId
   * @param {Number}   draft.year
   * @param {String}   draft.zipCode
   */
}
